import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
  },
  mailToAll: {
    marginTop: theme.spacing(2),
  },
  cardContainer: {
    display: "flex",
    justifyContent: "center",
  },
  card: {
    padding: theme.spacing(1),
  },
  makeDecisionCard: {
    padding: theme.spacing(2),
  },
  paddingBottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingBottom2: {
    paddingBottom: theme.spacing(2),
  },
  marginTop3: {
    paddingTop: theme.spacing(3),
  },
  button: {
    minHeight: 60,
    width: "100%",
  },
  helpIcon: {
    alignSelf: "center",
    marginLeft: 10,
  },
  statusInline: {
    display: "flex",
  },
  tooltip: {
    fontSize: theme.spacing(2),
  },
  buttonAssistantEditor: {
    backgroundColor: "coral",
    color: "white",
    minHeight: 60,
    width: "100%",
    fontWeight: 700,
  },
}));

export default useStyles;
